// ----------------------------------------------------------------------------
// Слушатели для разных элементов на странице /myaccount/
// ----------------------------------------------------------------------------

import {deleteAvatarHelp, deleteSocialNetworkHelp} from "../account/delete-something.js";
import {saveAvatarHelp} from "../account/save-something.js";
import {ttLKFocusName, ttMobMenuChange} from "../account/misc-functions.js";
import ttAuthLinkSend from "../account/tt-auth-link-send.js";
import ttLKSave from "../account/tt-LK-save.js";
import ttLKLogout from "../account/tt-LK-logout.js";
import {closePasswordForm, ttAuthPasswordShow, ttChangePassword} from "../auth-common/password-controller.js";

const listenersMyaccountMisc = function () {
    document.getElementById('js-myaccount-avatar-del-btn')?.addEventListener('click', deleteAvatarHelp);
    document.getElementById('ttAuth_ava')?.addEventListener('input', saveAvatarHelp);
    document.getElementById('js-load-ava')?.addEventListener('click', saveAvatarHelp);
    document.querySelectorAll('.js-myaccount-social-close-btn').forEach((social) => {
        social.addEventListener('click', deleteSocialNetworkHelp);
    });
    document.getElementById('js-edit-name-button')?.addEventListener('click', ttLKFocusName);
    document.getElementById('js-send-link-again')?.addEventListener('click', ttAuthLinkSend);
    document.getElementById('js-change-password')?.addEventListener('click', ttAuthPasswordShow);
    document.getElementById('js-change-password-2')?.addEventListener('click', ttChangePassword);
    document.getElementById('js-cancel-password')?.addEventListener('click', closePasswordForm);
    document.querySelectorAll('.js-ttLKSave').forEach((btn) => btn.addEventListener('click', ttLKSave));
    document.querySelectorAll('.myaccount-logout').forEach((btn) => btn.addEventListener('click', ttLKLogout));

    // для моб. меню
    document.getElementById('js-mobile-menu-select')?.addEventListener('change', (event) => {
        ttMobMenuChange(event.target.value);
    });
}

export default listenersMyaccountMisc;